import { render, staticRenderFns } from "./observe-chart.vue?vue&type=template&id=4af998b0&scoped=true&"
import script from "./observe-chart.vue?vue&type=script&lang=js&"
export * from "./observe-chart.vue?vue&type=script&lang=js&"
import style0 from "./observe-chart.vue?vue&type=style&index=0&id=4af998b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af998b0",
  null
  
)

export default component.exports